<template>
<div
    class="link"
    :class="{ 'has-text-grey-light': isUploadingFile }"
    @click="clickFileInput"
>
    <input
        ref="file"
        :disabled="isUploadingFile"
        class="is-hidden"
        type="file"
        @change="onFileChange"
    >
    <span class="icon">
        <i
            class="fas"
            :class="iconClass"
        ></i>
    </span>
    <span>
        {{ trans.upload_button }}
    </span>
</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "BaseFileUploadButton",
    data() {
        return {
            file: null,
        };
    },
    computed: {
        ...mapState('fileManagement', ['trans', 'actions', 'isUploadingFile']),
        ...mapGetters('fileManagement', ['isRequestInProgress']),
        iconClass() {
            return this.isUploadingFile ? 'fa-spinner fa-spin' : 'fa-file-upload';
        },
    },
    methods: {
        ...mapActions('fileManagement', ['loadBaseFiles', 'uploadBaseFile']),

        /**
         * Нажатие на скрытый инпут выбор файла
         */
        clickFileInput() {
            this.$refs.file.click();
        },

        /**
         * Обработчик изменения файла в инпуте выбора файлов
         * @param e
         */
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length) {
                return;
            }

            this.file = files[0];

            this.uploadBaseFile(this.file)
                .catch(error => {
                    let status = error.response.status,
                        errorString = this.trans.errors.upload_error_title;

                    switch (status) {
                        case 422: {
                            let errorList = error.response.data.errors;

                            for (let error in errorList) {
                                errorString += `<br>${errorList[error][0]}`;
                            }
                            break;
                        }

                        case 413: {
                            errorString += `<br>${this.trans.errors.file_size_is_too_large}`;
                            break;
                        }
                    }

                    this.showNotification(errorString, 680);
                })
                .finally(() => {
                    this.file = null;
                    this.$refs.file.value = null;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
    .link {
        text-decoration: none;
    }
</style>
